import { handleActions } from 'redux-actions';

import { clientEmailRecipientsSuccess, clientEmailSettingsSuccess } from './actions';

import initialState from './states';
import { logoutSuccess } from 'ducks/auth/actions';

export default handleActions(
  {
    [clientEmailSettingsSuccess](state, { payload: { clientID, settings } }) {
      return {
        ...state,
        settings: {
          ...state.settings,
          [clientID]: settings,
        },
      };
    },
    [clientEmailRecipientsSuccess](state, { payload: { recipients } }) {
      return {
        ...state,
        recipients,
      };
    },
    [logoutSuccess]() {
      return initialState;
    },
  },
  initialState
);
